module.exports = __webpack_public_path__ + "static/media/_MIC2667.thumbnail.b32c002a.png";